module.exports = __webpack_public_path__ + "img/cu.0a3ed034.svg";